<div class="flex flex-row flex-nowrap items-center gap-1">
  @if (meta().icon) {
    <soft-icon [name]="meta().icon" class="mr-2 scale-150"></soft-icon>
  }
  <div class="flex flex-col w-full">
    <soft-meta-label></soft-meta-label>
    <span class="soft-link text-sm" (click)="onClick()"> {{$any(value()) | metaFormat}}</span>
  </div>
</div>
